export default __webpack_public_path__ + "static/media/notification.f0dde63b.svg";